import { LOCATION_CHANGE, LocationChangeAction } from "react-router-redux";
import { all, takeEvery, put, select } from "redux-saga/effects";
import { Dispatch } from "redux";
import {
    getCampaignsListRequest,
    DashboardUrl,
    removeCampaignByIdRequest,
    getCampaignSpentBudgetRequest,
    getCurrenciesRequest
} from "@common";
import { removeCapmaignByIdAction, selectCampaignAction } from "./actions";
import { openNotificationAction } from "../page";
import { AppState } from "@store";
import { FetchingState } from "rd-redux-http";
import { currentClientId } from "@store";

export function removeCampaign(dispatch: Dispatch) {
    return function*(action: typeof removeCapmaignByIdAction.typeInterface) {
        const { clientId, campaignId } = action;

        try {
            const response: typeof removeCampaignByIdRequest.types.okResult = yield removeCampaignByIdRequest.saga({
                campaignId,
                clientId
            });

            if (response) {
                yield getCampaignsListRequest.saga({ clientId, _q: new Date().getTime() });
                yield put({
                    type: openNotificationAction.type,
                    isOpen: true,
                    message: "Campaign deleted!"
                });
            }
        } catch (e) {
            console.log(e);
        }
    };
}

function* loadCampaignsListOnNavigatingDashboard(a: LocationChangeAction) {
    try {
        const {
            campaignList: { campaigns }
        } = (yield select()) as AppState;

        const urlMatch = DashboardUrl.match(a.payload, true);
        if (urlMatch.isMatched) {
            if (FetchingState.hasParams(campaigns) && campaigns.params.clientId === urlMatch.params.clientId) {
                return;
            }

            yield* getCampaignsListRequest.saga({ clientId: urlMatch.params.clientId, _q: new Date().getTime() });
        }

        yield* getCurrenciesRequest.saga({});
    } catch (e) {
        console.error(e);
    }
}

export function* tryLoadCampaignSpentBudget(campaignId: string) {
    const state: AppState = yield select();

    const campaign = FetchingState.getDataOrDefault(state.campaignList.campaigns, []).find(
        c => c.campaignId === campaignId
    );

    if (!campaign || campaign.status === "draft" || campaign.status === "pending") {
        return;
    }

    const campaignSpentBudget = state.campaignList.campaignSpentBudget[campaignId];

    if (!campaignSpentBudget || FetchingState.isError(campaignSpentBudget)) {
        try {
            yield* getCampaignSpentBudgetRequest.saga({ campaignId, clientId: currentClientId(state) });
        } catch (e) {
            console.error(e);
        }
    }
}

export function* dashboardSaga(dispatch: Dispatch) {
    yield all([
        takeEvery(
            (a: LocationChangeAction) => a.type === LOCATION_CHANGE && DashboardUrl.match(a.payload, true).isMatched,
            loadCampaignsListOnNavigatingDashboard
        ),
        takeEvery(removeCapmaignByIdAction.type, removeCampaign(dispatch)),
        takeEvery(selectCampaignAction.type, function*(a: typeof selectCampaignAction.typeInterface) {
            yield* tryLoadCampaignSpentBudget(a.campaignId);
        })
    ]);
}
